<template>
  <div class="wraper" :class="{'mobile':isMobile, 'pc': !isMobile}">
    <div class="module-item" v-for="(item, index) in data.module_list">
      <appointment-base
        v-if="item.module_type==1"
        :step="step"
        :partyId="partyId"
        :pageName="data.page_name"
        :showModal="showModal"
        :moduleData="item"
        :pageType="pageType"
        :pageInfo="pageInfo"
        :needKYC="needKYC"
        @setStep="setStep"
        @setHasFa="setHasFa"
        @setFirstTime="setFirstTime"
        @setGroupNo="setGroupNo"
        @setShowModal="setShowModal"
      />
      <appointment-qualification v-else-if="item.module_type==2"
        :step="step"
        :partyId="partyId"
        :pageName="data.page_name"
        :showModal="showModal"
        :moduleData="item"
        :pageType="pageType"
        :pageInfo="pageInfo"
        :needKYC="needKYC"
        @setStep="setStep"
        @setHasFa="setHasFa"
        @setGroupNo="setGroupNo"
        @setShowModal="setShowModal"
      />
      <questionnaire v-else-if="item.module_type==3"
        :moduleData="item"
        :step="step"
        :showModal="showModal"
        :pageInfo="pageInfo"
        :groupNo="groupNo"
        @setStep="setStep"
      />
      <content-base v-else-if="item.module_type==4" :moduleData="item" @consult="consult" />
      <content-drop v-else-if="item.module_type==5" :moduleData="item" :pageName="data.page_name" />
      <link-base v-else-if="item.module_type==6" :moduleData="item" />
      <appointment-internal
        v-else-if="item.module_type==7"
        :step="step"
        :partyId="partyId"
        :pageName="data.page_name"
        :showModal="showModal"
        :moduleData="item"
        :pageType="pageType"
        :pageInfo="pageInfo"
        :needKYC="needKYC"
        @setStep="setStep"
        @setHasFa="setHasFa"
        @setGroupNo="setGroupNo"
        @setShowModal="setShowModal"
      />
      <content-float v-else-if="item.module_type==8" :moduleData="item" @consult="consult" />
      <loading v-else-if="item.module_type==9" :moduleData="item" :showLoading="showLoading" />
      <carousel-map v-else-if="item.module_type==10" :moduleData="item" />
      <appointment-membership v-if="item.module_type==11"
        :step="step"
        :partyId="partyId"
        :pageName="data.page_name"
        :showModal="showModal"
        :moduleData="item"
        :pageType="pageType"
        :pageInfo="pageInfo"
        :needKYC="needKYC"
        @setStep="setStep"
        @setHasFa="setHasFa"
        @setFirstTime="setFirstTime"
        @setGroupNo="setGroupNo"
        @setShowModal="setShowModal"
      />
    </div>
  </div>
</template>

<script>
import Utils from "../assets/js/util";
import { pageInfo } from "../api/api";
import { checkExternalUser, externalUser } from "../api/wechatApi"
import { getCookieByName } from "@/utils/dataStatistics"
import appointmentBase from './modules/appointment-base';
import appointmentQualification from './modules/appointment-qualification';
import appointmentInternal from './modules/appointment-internal';
import contentBase from './modules/content-base';
import contentDrop from './modules/content-drop';
import contentFloat from './modules/content-float';
import linkBase from './modules/link-base';
import questionnaire from './modules/questionnaire';
import loading from './modules/loading'
import carouselMap from './modules/carousel-map'
import appointmentMembership from './modules/appointment-membership'
import invoke from 'react-native-webview-invoke/browser'
import { Toast } from 'vant'
import encrypt, { Decrypt } from '../api/encrypt'

// 由企业微信发过来的链接注册
export const saveExternalUser = async (mobilePhone, groupNo)=> {
  const externalUserid = getSearchString('code') && decodeURIComponent(getSearchString('code'))
  const inviteUserid = getSearchString('inviteUserid') && decodeURIComponent(getSearchString('inviteUserid'))
  if (externalUserid && inviteUserid) {
    const pubKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKtSNn1DQqCGl4ychDnbVS0frWdoyG3m7JsyCzQzRJLxpPxIovUCuCoT8RS1dtHv7zP5OIE4EhNkFZWsM5qMJwkCAwEAAQ=='
    const phone = encrypt(pubKey, mobilePhone)
    const res = await externalUser({
      externalUserid,
      inviteUserid: encrypt(pubKey, Decrypt(inviteUserid)),
      phone,
      phoneType: '156',
      groupNo: encrypt(pubKey, groupNo),
      corpId: getSearchString('state')
    })
    if (res.data.code === 200) {
      console.log(res.data.resultMessage)
    }
  }
}

// 获取浏览器对应的参数
export function getSearchString (key, link) {
  const url = link ? link : window.location.href
  const num = url.indexOf('?')
  const str = url.substring(num + 1, url.length) // 获取URL中?之后的字符（去掉第一位的问号）
  const arr = str.split('&')
  const obj = {}
  // 将每一个数组元素以=分隔并赋给obj对象
  for (let i = 0; i < arr.length; i++) {
    const tmpArr = arr[i].split('=')
    obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1])
  }
  return obj[key]
}

// 时间戳转化成时间
export function timetrans(time){
  const date = new Date(time);//如果date为10位不需要乘1000
  const Y = date.getFullYear() + '-';
  const M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  const D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return Y + M + D + h + m + s
}

export function openUrl (url) {
  const fromApp = getSearchString('fromApp')
  if (fromApp === 'smileFund') {
    const jumpToApp = invoke.bind('jumpToApp')
    const linkToFundDetail = invoke.bind('linkToFundDetail')
    const reserveId = getSearchString('reserveId', url)
    const fundType = getSearchString('fundType', url)
    const fundId = getSearchString('fundId', url)
    if (reserveId || fundType) { // 跳转私募
      return jumpToApp('ProductDetail', { reserveId, fundType }, true)
    } else if (fundId) { // 跳转公募
      return linkToFundDetail(fundId)
    } else {
      window.open(url, '_blank')
    }
  } else {
    window.open(url, '_blank')
  }
}
/**
 * type: 1  预约弹窗-基础样式
 * type: 2  预约弹窗-投资认定样式
 * type: 3  KYC调研问卷
 * type: 4  页面内容-基础样式
 * type: 5  页面内容-下拉样式  只在PC端展示
 * type: 6  扩展链接-基础样式
 * type: 7  预约弹窗-内置留资样式  只在移动端展示
 * type: 8  页面内容-悬浮组件  只在移动端展示
 * type: 9  页面内容-Loading组件  只在移动端展示
 * type: 10  页面内容-轮播组件  只在移动端展示
 */
export default {
  name: "index",
  components: {
    appointmentBase,
    appointmentQualification,
    appointmentInternal,
    contentBase,
    contentDrop,
    contentFloat,
    linkBase,
    questionnaire,
    loading,
    carouselMap,
    appointmentMembership
  },
  data() {
    return {
      id: null,
      data: {},
      partyId: '',
      isMobile: Utils.device.isMobile,
      showModal: false,
      pageType: undefined,
      step: 1,  // 1 预约弹窗  2 KYC 3 结果弹窗
      hasKyc: false,
      hasFa: false,  // 是否有绑定的理财师
      hasInternal: false, // 是否内置预约留资样式
      pageInfo: {},
      entryTime: 0,
      leaveTime: 0,
      needKYC: false, // 是否需要KYC
      isFirstTime: false,  // 该手机号是否是NCCP首次注册，false代表首次
      groupNo: '',
      showLoading: true
    };
  },
  methods: {
    // 处理悬浮组件打开web链接
    openUrl (data) {
      const reserveId = getSearchString('reserveId', data.url)
      this.$sensors.track('pptf_float_button_click', {
        ...this.pageInfo,
        button_type: 'web链接',
        button_id: data.btnId,
        item_type: '落地页预约',
        item_id: this.pageInfo.toufang_id,
        // channel_source_id: this.pageInfo.toufang_id,
        reserveId
      })
      openUrl(data.url)
    },
    // 锚点到内置留资位置
    scrollToInternal () {
      const internalEle = document.getElementById('internal');
      internalEle.scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
      })
    },
    // 打开预约留资弹窗
    openAppointment (data) {
      if (data && data.btnType === '1') {
        this.$sensors.track('pptf_float_button_click', {
          ...this.pageInfo,
          button_type: '预约留资',
          button_id: data.btnId,
          item_type: '落地页预约',
          channel_source_id: this.pageInfo.toufang_id
        })
      }
      this.$sensors.track('pptf_profile_pop', {
        ...this.pageInfo
      })
      this.showModal = true
    },
    // 点击预约留资和悬浮组件按钮
    consult (data) {
      if (data && data.btnType === '2') { // 悬浮组件点击web链接
        this.openUrl(data)
      } else {
         if (this.hasInternal) { // 含有内置留资
           this.scrollToInternal()
         } else {
           this.openAppointment(data)
         }
      }
    },
    // 设置弹窗状态
    setShowModal(boolean) {
      this.showModal = boolean;
    },
    // 设置当前展示的弹窗类型
    setStep(step) {
      // 如果有绑定理财师或者没有添加KYC问卷，直接弹出留资结束的弹窗
      if(step == 2 && (this.hasFa ||!this.hasKyc)) {
        step++;
      }
      this.showModal = true;
      this.step = step;
      if (this.step == 2) { // 显示KYC问卷打点
        this.$sensors.track('pptf_kyc_pop', {
          ...this.pageInfo,
          customer_id: this.groupNo,
          distinct_id: this.groupNo
        })
      }
    },
    // 设置是否绑定理财师
    setHasFa(boolean) {
      this.hasFa = boolean;
      if (boolean) this.needKYC = false
    },
    // 设置是否首次注册
    setFirstTime(boolean) {
      this.isFirstTime = boolean
    },
    // 设置集团号
    setGroupNo(groupNo) {
      this.groupNo = groupNo
      this.pageInfo.customer_id = groupNo
      this.$sensors.login(groupNo)
    },
    // 离开落地页打点
    handlePagehide () {
      this.leaveTime = new Date().getTime()
      const duration = Math.floor((this.leaveTime - this.entryTime) / parseFloat(1000))
      this.$sensors.track('pptf_homepage_duration', {
        ...this.pageInfo,
        duration,
        enter_ts: timetrans(this.entryTime),
        leave_ts: timetrans(this.leaveTime),
        item_type: '落地页',
        item_id: this.pageInfo.toufang_id,
        item_name: this.pageInfo.toufang_name
      })
    },
    // 当落地页是客服从企业微信发出时，带有code参数为联系人的userId，此时校验链接是否过期
    async checkLink () {
      const externalUserid = getSearchString('code') && decodeURIComponent(getSearchString('code'))
      if (externalUserid) {
        const res = await checkExternalUser({ externalUserid, corpId: getSearchString('state') })
        if (res.data.code !== 200) {
          Toast({
            type: 'fail',
            message: res.data.resultMessage,
            overlay: true,
            forbidClick: true,
            duration: 0
          })
        }
      }
    }
  },
  created () {
    this.checkLink()
    const id = this.$route.params.id;
    this.partyId = this.$route.query.partyId;
    pageInfo({ id }).then(res => {
      if (res.data.msg == "处理成功") {
        this.data = res.data.data;
        this.pageType = this.data.page_type;
        this.hasKyc = !!this.data.kyc_status;
        document.title = this.data.page_title;
        if (this.data.page_type == 1) {
          this.showModal = true
        } else if (this.data.page_type == 2) {
          setTimeout(() => {
            this.showModal = true
          }, 3000)
        }
        this.data.module_list.forEach(v => {
          if (v.module_type == 8 && !v.btnList) {
            v.btnList = [{ btnType: '1' }]
          } else if (v.module_type == 3) {
            this.needKYC = true
          } else if (v.module_type == 7 || v.module_type == 11) {
            this.hasInternal = true
          } else if (v.module_type == 9) {
            setTimeout(() => {
              this.showLoading = false
            }, 2000)
          }
        })
        this.entryTime = new Date().getTime()
        this.pageInfo = { // 打点数据全局属性
          ...this.pageInfo,
          toufang_id: this.data.id,
          toufang_name: this.data.page_name,
          platform: this.data.client_type,
          is_auto_pop: this.data.page_type > 0 ? 'true' : 'false',
          is_assign_city: this.$route.query.city ? '是' : '否',
          assign_city: this.$route.query.city ? this.$route.query.city : ''
        }
        // 落地页展示打点
        const external_userid = getSearchString('userid') && decodeURIComponent(getSearchString('userid'))
        const follow_user_state = getSearchString('followState') && decodeURIComponent(getSearchString('followState'))
        const fa_mail = getSearchString('inviteEmail') && decodeURIComponent(getSearchString('inviteEmail'))
        const fa_id = getSearchString('inviteUserid') && decodeURIComponent(getSearchString('inviteUserid'))
        const from_corp = getSearchString('fromCorp') && decodeURIComponent(getSearchString('fromCorp'))
        this.$sensors.track('pptf_homepage_pageview', {
          ...this.pageInfo,
          item_type: '落地页',
          item_id: this.pageInfo.toufang_id,
          item_name: this.pageInfo.toufang_name,
          external_userid: external_userid ? Decrypt(external_userid) : '',
          follow_user_state: follow_user_state ? Decrypt(follow_user_state) : '',
          fa_mail: fa_mail ? Decrypt(fa_mail) : '',
          fa_id: fa_id ? Decrypt(fa_id) : '',
          from_corp: from_corp ? from_corp : ''
        })
        // 强制弹窗打点
        if (this.data.page_type > 0) {
          this.$sensors.track('pptf_profile_pop', {
            ...this.pageInfo
          })
        }
      }
    })
  },
  mounted () {
    const fromApp = getSearchString('fromApp')
    if (fromApp === 'smileFund') { // 从微笑基金APP打开落地页
      const groupId = getSearchString('groupId')
      if (groupId) {
        this.$sensors.registerPage({
          customer_id: groupId
        })
        this.$sensors.login(groupId)
      }
    } else {
      this.$goLogin((success) => {
        this.$sensors.registerPage({
          customer_id: success.uid
        })
        this.$sensors.login(success.uid)
      }, (fail) => {
        console.log(fail)
      })
      this.$sensors.registerPage({
        customer_id: getCookieByName("group_no")
      })
      this.$sensors.login(getCookieByName("group_no"))
    }
    if (this.isMobile) {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.handlePagehide()
        }
      })
    } else {
      window.addEventListener('pagehide', this.handlePagehide)
    }
  }
};
</script>

<style lang="less">
html,
body,
input,
p {
  margin: 0;
  padding: 0;
}
img {
  display: block;
}

input {
  // -webkit-appearance: none;
  // appearance: none;
  // outline: none;
  border: none;
}
.wraper {
  width: 100%;
  background: #fff;
}

.noscroll {
  width: 100vw;
  // height: 100vh;
  overflow: hidden;
}
.module-item {
  width: 100%;
}
.ctt-module {
  width: 100%;
  position: relative;
}
.ctt-module img {
  width: 100%;
}

.ctt-module .btn {
  width: 4.7rem;
  height: 0.92rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1rem;
  cursor: pointer;
}

// @media screen and (max-width: 1400px) {
//  .ctt-module .btn {
//    width: 3.3rem;
//    height: .64rem;
//    bottom: .7rem;
//  }
// }
// @media only screen and (min-width: 1400px) {
//     .income-block {
//       width: 250px;
//     }
//   }
.link-module {
  width: 100%;
  // height: 300px;
  position: relative;
  z-index: 2;
}

.link-module-bg {
  width: 100%;
}

.link-imgs {
  width: 11.8rem;
  // height: 1.5rem;
  position: absolute;
  left: 50%;
  top: 1.1rem;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .link-img-a {
    width: 2.8rem;
    // height: 1.7rem;
    cursor: pointer;
    background: #fff;
    display: block;
    text-decoration: none;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

    .link-img {
      width: 2.8rem;
      height: 2.56rem;
      cursor: pointer;
      display: block;
    }

    .link-title {
      width: 100%;
      height: .84rem;
      padding: .2rem .26rem;
      font-size: .17rem;
      line-height: .35rem;
      color: black;
      box-sizing: border-box;
      font-family: "PingFangSC";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
    }
  }
  .link-img-a:hover {
    // transform: translateX(5px);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);

    .link-title {
      color: #FBA849;
    }
  }
}

.mobile {
  .ctt-module .btn {
    width: 6.1rem;
    height: 1.2rem;
    bottom: 1rem;
  }

  .link-imgs {
    width: 7rem;
    // height: 3.62rem;
    position: absolute;
    left: 50%;
    top: 1.5rem;
    transform: translateX(-50%);
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-content: space-between;

    .link-img-a {
      width: 3.36rem;
      margin-right: .2rem;
      margin-bottom: .2rem;
    }

    .link-img-a:nth-child(2n) {
      margin-right: 0;
    }
    .link-img-a:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }

    .link-img {
      width: 3.4rem;
      height: 3.08rem;
    }

    .link-title {
      width: 100%;
      height: 1rem;
      padding: .16rem .24rem;
      font-size: .24rem;
      line-height: .32rem;
      color: black;
      box-sizing: border-box;
      font-family: "PingFangSC";
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-decoration: none;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/index.vue